import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { StudentTour } from '../../models/StudentTour';

export interface StudentTourState {
  value: StudentTour | null;
}

const initialState: StudentTourState = { value: StudentTour.ALL_SKILLS };

export const studentTourSlice = createSlice({
  name: 'studentTour',
  initialState,
  reducers: {
    setStudentTour: (state: StudentTourState, action: PayloadAction<StudentTour | null>) => {
      state.value = action.payload;
    },
  },
});

export const selectedStudentTour = (state: RootState) => state.studentTour.value;

export const { setStudentTour } = studentTourSlice.actions;

export default studentTourSlice.reducer;
